import { Bell, CalendarDays, History, Home, Shield, User, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';

import { PortalLayout, type NavSection, type PortalMenuItem } from './PortalLayout';

const NAV_SECTIONS: NavSection[] = [
  {
    items: [
      { to: '/employee', label: 'Home', icon: Home, end: true },
      { to: '/employee/visitors', label: 'Invitations', icon: Users },
      { to: '/employee/events', label: 'Events', icon: CalendarDays },
      { to: '/employee/history', label: 'Visitor History', icon: History },
      { to: '/employee/notifications', label: 'Notifications', icon: Bell },
      { to: '/employee/account', label: 'Account', icon: User },
    ],
  },
];

const MENU_ITEMS: PortalMenuItem[] = [
  { to: '/employee/account', label: 'Profile', icon: User },
  { to: '/employee/account/privacy', label: 'Privacy & Data', icon: Shield },
];

const ACTIVE_CLASS =
  'border-l-2 border-[var(--text-accent)] text-[var(--text-accent)] bg-[var(--bg-surface-raised)]';
const INACTIVE_CLASS = 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]';

function getGreeting(firstName: string): string {
  const h = new Date().getHours();
  if (h < 12) return `Good morning, ${firstName}`;
  if (h < 17) return `Good afternoon, ${firstName}`;
  return `Good evening, ${firstName}`;
}

function Brand() {
  return (
    <div className="border-b border-[var(--bg-surface-raised)] pb-3">
      <Link to="/employee" className="flex flex-col px-2 pt-1 gap-0.5">
        <span
          className="text-lg leading-none text-[var(--text-accent)] brand-name"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Secure Labs
        </span>
        <span className="text-[10px] text-[var(--text-tertiary)] tracking-wide group-data-[collapsible=icon]:hidden">
          Employee Portal
        </span>
      </Link>
    </div>
  );
}

function HeaderContent() {
  const { user } = useAuth();
  const firstName = user?.fullName.split(' ')[0] ?? 'there';
  return (
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-[var(--text-primary)] truncate">
        {getGreeting(firstName)}
      </p>
    </div>
  );
}

export function EmployeeLayout() {
  return (
    <PortalLayout
      brand={<Brand />}
      navSections={NAV_SECTIONS}
      notificationsTo="/employee/notifications"
      activeClassName={ACTIVE_CLASS}
      inactiveClassName={INACTIVE_CLASS}
      headerContent={<HeaderContent />}
      menuItems={MENU_ITEMS}
    />
  );
}
